export default [
  {
    path: '/closures',
    name: 'Closures-list',
    component: () => import('@/components/adm/closures/ClosuresList.vue'),
    meta: {
      title: "Controle Leiteiro > Encerramentos"
    }
  }
]